export default __webpack_public_path__ + "static/media/bg-img.0c5628a9.png";